export const view06ImageOptions = {
  angle: 'View06',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    TeakOnCoachroof: 1,
    BathingPlatform: 1,
    TeakOnBathingPlatform: 1,
    SprayHood: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X43/views/View06.js